import React, { useMemo } from 'react';
import success from '../../animations/success.json';
import { sanitizeLottieName } from '../../utils/sanitize';
import { getInlineStyles } from '../../utils/styles';
import { TLottieAnimationViewProps } from './LoadingAnimationView';
import { recolorLottie } from './recolorLottie';
import { useLottieAnimation } from './useLottieAnimation';

export const SuccessAnimationView = ({ uid, animationsColor, margin }: TLottieAnimationViewProps) => {
    const sanitizedUid = sanitizeLottieName(uid ?? 'success');

    const animationData = useMemo(() => (animationsColor ? recolorLottie(success, animationsColor) : success), [animationsColor]);

    const { element } = useLottieAnimation({
        uid: sanitizedUid,
        animationData,
        loop: false,
        autoplay: true,
    });

    return <div data-test={uid} ref={element} style={getInlineStyles({ margin, height: '73px', width: '73px' })} />;
};
